import { render, staticRenderFns } from "./PromoImages.vue?vue&type=template&id=3cbafb0e&scoped=true"
import script from "./PromoImages.vue?vue&type=script&lang=js"
export * from "./PromoImages.vue?vue&type=script&lang=js"
import style0 from "./PromoImages.vue?vue&type=style&index=0&id=3cbafb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbafb0e",
  null
  
)

export default component.exports